<section>
  <form class="needs-validation" novalidate [formGroup]="formVisit">
    <div class="row p-2">
      <div class="col">
        <app-custom-select formControlName="conceptId" [required]="true" [labelText]="'Concepto Cancelación'"
          [list]="listConcept"></app-custom-select>
      </div>
    </div>
    <div class="row px-2 pb-2">
      <div class="col">
        <app-custom-textarea formControlName="observationCancel" [labelText]="'Observación Cancelación'"
          [required]="true" [autoResize]="false" [rows]="1" [maxLength]="1000"></app-custom-textarea>
      </div>
    </div>
  </form>
</section>
<section>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-3 gap-2">
      <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disable"
        (onClick)="send()"></app-custom-button>
      <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'"
        (onClick)="close(false)"></app-custom-button>
    </div>
  </div>
</section>